module.exports = __webpack_public_path__ + "d2c0b5483c98ca9e64c8b215e5ea140d.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/en.json
// module id = 1037
// module chunks = 0